import React from "react";
import locale from "@bonliva-crm/locale";
import { BriefcasePlus, Refresh } from "mdi-material-ui";
import { Fab, Button, CircularProgress } from "@material-ui/core";
import ActionBar from "@search/ActionBar";
import { WithTooltip } from "@components";
import {
  useSyncTimeReportsWithBookingSearchMutation,
  TimereportKitSupportSearch_Get
} from "@graphql";
import { useSnackbars } from "@hooks";

type Props = {
  onDirectBooking: () => void;
  total?: React.ReactNode;
  withTotal?: boolean;
  withSyncTimeReport?: boolean;
  bookingIds?: string[];
};

export function BookingSearchActionBar(props: Props) {
  const { onDirectBooking, total } = props;
  const { showSuccess, showError } = useSnackbars();
  const [sync, { loading }] = useSyncTimeReportsWithBookingSearchMutation();
  const handleSync = () => {
    sync({
      variables: { ids: props?.bookingIds ?? [] },
      refetchQueries: [TimereportKitSupportSearch_Get.OperationName]
    })
      .then(() => {
        showSuccess("Status för tidrapporter uppdaterade!");
      })
      .catch((err) => showError(`Kunde inte uppdatera tidrapporter: ${err.toString()}`));
  };

  return (
    <ActionBar
      actions={[
        <WithTooltip title={locale["Add new booking"]} key="addBooking">
          <Fab key="new" color="primary" onClick={onDirectBooking} size="small">
            <BriefcasePlus />
          </Fab>
        </WithTooltip>,
        <div>
          {props.withSyncTimeReport && (
            <Button
              key="syncTRStatus"
              onClick={handleSync}
              startIcon={loading ? <CircularProgress size={16} /> : <Refresh />}
            >
              Uppdatera status för tidrapport
            </Button>
          )}
        </div>
      ]}
      total={total}
      totalLoading={props.withTotal ? total == null : false}
      withTotalLabel={props.withTotal}
    />
  );
}
